import http from "@seims/shared/src/services/HttpService";

var endpoint = `/lookup/candidate/`;

const getPlacementStatus = async () => {
    const response = await http.get(`${endpoint}placementStatus`);
    return response;
  };
  const getPreNYSActivity = async () => {
    const response = await http.get(`${endpoint}preNYSActivity`);
    return response;
  };
  const getExitDirection = async () => {
    const response = await http.get(`${endpoint}exitDirection`);
    return response;
  };

  const getDuration = async () => {
    const response = await http.get(`${endpoint}durationInNYS`);
    return response;
  };

  export default  { 
    getPreNYSActivity,
    getPlacementStatus,
    getExitDirection,
    getDuration
  };